var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.33333 0.286377L6.33333 1.28638L9.38021 4.33325H0V5.66658H9.38021L6.33333 8.71346L7.33333 9.71346L12.0469 4.99992L7.33333 0.286377Z"}));
}

ArrowRight.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
